<template>
    <div class="sidebar-tool" :class="{ active: isMenuActive(), 'mobile-sidebar': isMobile, [className]: className }">
        <div class="sidebar-content" @mouseenter="mouseEnterStart" @mouseleave="mouseLeaveStart">
            <div class="sidebar-title" v-if="titleEnabled && isMenuActive()">
                <slot name="title"></slot>
            </div>
            <div class="sidebar-menu" v-if="cloneItems.length > 0">
                <div class="sidebar-menu-content">
                    <draggable
                        v-if="enableNonGroupedDraggable"
                        v-model="cloneItems"
                        :options="getDraggableOptions()"
                        @end="onNonGroupedDragEnd"
                        style="width: 100%;"
                    >
                        <template v-for="item of cloneItems">
                            <SidebarItemTooltip
                                :key="item.key"
                                :title-text="item.label"
                                :rich-description="item.filterDescription || ''"
                                :filter-icon="item.filterData ? item.icon : null"
                                :menu-active="isMenuActive()"
                            >
                                <router-link v-if="item.route" :to="item.route" class="menu-item" @click.native="handleRouteClick(item, $event)">
                                    <SidebarChildItem
                                        :item="item"
                                        :isSelected="isSelected"
                                        :isMenuActive="isMenuActive"
                                        :showSearchButton="item.showSearchButton"
                                        :searchCallback="item.searchCallback"
                                    />
                                </router-link>
                                <SidebarChildItem
                                    v-else
                                    :item="item"
                                    :isSelected="isSelected"
                                    :isMenuActive="isMenuActive"
                                    @selected="fnCallback"
                                    @clicked="fnCallback"
                                    :showSearchButton="item.showSearchButton"
                                    :searchCallback="item.searchCallback"
                                />
                            </SidebarItemTooltip>
                        </template>
                    </draggable>
                    <template v-else>
                        <template v-for="item of cloneItems">
                            <SidebarItemTooltip
                                :key="item.key"
                                :title-text="item.label"
                                :rich-description="item.filterDescription || ''"
                                :filter-icon="item.filterData ? item.icon : null"
                                :menu-active="isMenuActive()"
                            >
                                <router-link v-if="item.route" :to="item.route" class="menu-item" @click.native="handleRouteClick(item, $event)">
                                    <SidebarChildItem
                                        :item="item"
                                        :isSelected="isSelected"
                                        :isMenuActive="isMenuActive"
                                        :showSearchButton="item.showSearchButton"
                                        :searchCallback="item.searchCallback"
                                    />
                                </router-link>
                                <SidebarChildItem
                                    v-else
                                    :item="item"
                                    :isSelected="isSelected"
                                    :isMenuActive="isMenuActive"
                                    @selected="fnCallback"
                                    @clicked="fnCallback"
                                    :showSearchButton="item.showSearchButton"
                                    :searchCallback="item.searchCallback"
                                />
                            </SidebarItemTooltip>
                        </template>
                    </template>
                </div>
            </div>
            <div class="sidebar-grouped" v-for="groupItem of groupedItems" :key="groupItem.name">
                <a-tooltip
                    :title="groupItem.name"
                    placement="right"
                    :overlayClassName="isMenuActive() ? '' : 'hiddenToolTip'"
                >
                    <div class="sidebar-grouped-head" @click="toggleSubMenu(groupItem)" @touchend.prevent="toggleSubMenu(groupItem)">
                        <div class="sidebar-grouped-head-title">{{ groupItem.name }}</div>
                        <div class="sidebar-grouped-head-collapse">
                            <div class="material-icons">{{ groupItem.showMore ? "expand_less" : "expand_more" }}</div>
                        </div>
                    </div>
                </a-tooltip>
                <div class="sidebar-menu" :class="{ closed: !groupItem.showMore }">
                    <div class="sidebar-menu-content">
                        <template v-if="groupItem.items.length === 0">
                            <slot :name="groupItem.name + '-empty'"></slot>
                        </template>
                        <template v-else>
                            <draggable
                                v-if="groupItem.isDraggable"
                                v-model="groupItem.items"
                                :options="getDraggableOptions()"
                                @end="onDragEnd(groupItem)"
                                style="width: 100%;"
                            >
                                <template v-for="item of groupItem.items">
                                    <SidebarItemTooltip
                                        :key="item.key"
                                        :title-text="item.label"
                                        :rich-description="item.filterDescription || ''"
                                        :filter-icon="item.filterData ? item.icon : null"
                                        :menu-active="isMenuActive()"
                                    >
                                        <router-link v-if="item.route" :to="item.route" @click.native="handleRouteClick(item, $event)">
                                            <SidebarChildItem
                                                :item="item"
                                                :isSelected="isSelected"
                                                :isMenuActive="isMenuActive"
                                                :showSearchButton="item.showSearchButton"
                                                :searchCallback="item.searchCallback"
                                            />
                                        </router-link>
                                        <SidebarChildItem
                                            v-else
                                            :item="item"
                                            :isSelected="isSelected"
                                            :isMenuActive="isMenuActive"
                                            @selected="fnCallback"
                                            :showSearchButton="item.showSearchButton"
                                            :searchCallback="item.searchCallback"
                                        />
                                    </SidebarItemTooltip>
                                </template>
                            </draggable>
                            <template v-else>
                                <template v-for="item of groupItem.items">
                                    <SidebarItemTooltip
                                        :key="item.key"
                                        :title-text="item.label"
                                        :rich-description="item.filterDescription || ''"
                                        :filter-icon="item.filterData ? item.icon : null"
                                        :menu-active="isMenuActive()"
                                    >
                                        <router-link v-if="item.route" :to="item.route" @click.native="handleRouteClick(item, $event)">
                                            <SidebarChildItem
                                                :item="item"
                                                :isSelected="isSelected"
                                                :isMenuActive="isMenuActive"
                                                :showSearchButton="item.showSearchButton"
                                                :searchCallback="item.searchCallback"
                                            />
                                        </router-link>
                                        <SidebarChildItem
                                            v-else
                                            :item="item"
                                            :isSelected="isSelected"
                                            :isMenuActive="isMenuActive"
                                            @selected="fnCallback"
                                            :showSearchButton="item.showSearchButton"
                                            :searchCallback="item.searchCallback"
                                        />
                                    </SidebarItemTooltip>
                                </template>
                            </template>
                        </template>
                    </div>
                </div>
            </div>
        </div>
        <div class="sidebar-tool-collapse" @click="toggle" @touchend.prevent="toggle">
            <div class="information-text">{{ $t("message.showHide") }}</div>
            <div>
                <div class="material-icons">{{ isMenuActive() ? "chevron_left" : "chevron_right" }}</div>
            </div>
        </div>
    </div>
</template>

<script>
import SidebarChildItem from "./SidebarChildItem.vue";
import SidebarItemTooltip from "./SidebarItemTooltip.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import draggable from "vuedraggable";

const AUTO_OPEN_DELAY = 400;
const AUTO_CLOSE_DELAY = 300;
export default {
    name: "SidebarChild",
    components: { SidebarChildItem, SidebarItemTooltip, draggable },
    props: {
        titleEnabled: {
            type: Boolean,
            default: false,
        },
        tabs: {
            type: Array,
            default: () => [],
        },
        items: {
            type: Array,
            default: () => [],
        },
        selectedItem: {
            type: [String, Number],
            default: null,
        },
        focusActive: {
            type: Boolean,
            default: false,
        },
        defaultOpen: {
            type: Boolean,
            default: false,
        },
        enableNonGroupedDraggable: {
            type: Boolean,
            default: false,
        },
        className: {
            type: String,
            default: "",
        },
    },
    computed: {
        ...mapState({
            isMobile: (state) => state.app.isMobile,
            menu: (state) => state.layout.menu,
            adminUser: (state) => state.auth.adminUser,
        }),
        ...mapGetters({
            checkPermission: "auth/checkPermission",
        }),
    },
    data() {
        return {
            isActive: false,
            groupedItems: [],
            cloneItems: [],
            selectedItemClone: null,
            hoverActive: false,
            hoverTimerId: null,
        };
    },
    created() {
        this.isActive = this.defaultOpen;
    },
    methods: {
        ...mapActions({
            toggleMenu: "layout/toggleMenu",
        }),
        mouseEnterStart() {
            this.hoverTimerId = setTimeout(() => {
                this.hoverActive = true;
                this.toggleMenu(false);
            }, AUTO_OPEN_DELAY);
        },
        mouseLeaveStart() {
            if (this.hoverTimerId) clearTimeout(this.hoverTimerId);
            setTimeout(() => {
                this.hoverActive = false;
            }, AUTO_CLOSE_DELAY);
        },
        isSidebarMenu() {
            return this.menu.isOpen || this.menu.hoverActive;
        },
        isMenuActive() {
            return !this.isSidebarMenu() && (this.isActive || (this.focusActive && this.hoverActive));
        },
        toggle() {
            this.isActive = !this.isActive;
            if (this.isActive) {
                this.toggleMenu(false);
            }
        },
        toggleSubMenu(group) {
            group.showMore = !group.showMore;
        },
        isSelected(item) {
            if(item.isSelected) {
                return true;
            }
            const selectedItem = this.items.find(
                (i) => i.key === this.selectedItemClone || i.parentKey === this.selectedItemClone
            );
            return item && selectedItem && (item.key === selectedItem.key || item.key === selectedItem.parentKey);
        },
        fnCallback(item) {
            if (item.clickEvent) {
                console.log("fnCallback -> clickEvent", item.clickEvent);
                this.$emit("clicked", item);
            } else {
                console.log("fnCallback -> selected", item);
                this.selectedItemClone = item?.parentKey || item.key;
                this.$emit("selected", item);
            }
            if (typeof item.clickCallback === "function") {
                console.log("fnCallback -> clickCallback", item.clickCallback);
                item.clickCallback();
            }
            if (item.path) {
                console.log("fnCallback -> path", item.path);
                this.$router.push(item.path);
            }
        },
        initData() {
            let items = this.$_.cloneDeep(this.items);
            this.selectedItemClone = this.selectedItem || items[0]?.key;
            items = items.reduce(
                (acc, item) => {
                    if (!item.enabled) return acc;
                    if (this.adminUser && item.superAdminPageKey && !this.hasSuperAdminAccess(item.superAdminPageKey)) {
                        return acc;
                    }
                    if (item.group) {
                        acc.grouped[item.group] = {
                            name: item.group,
                            showMore: this.$_.get(this.groupedItems, `${item.group}.showMore`, true),
                            isDraggable: this.$_.get(this.groupedItems, `${item.group}.isDraggable`, true),
                            items: [...(acc.grouped[item.group]?.items || []), item],
                        };
                    } else {
                        acc.noGrouped.push(item);
                    }
                    return acc;
                },
                {
                    grouped: {
                        ...this.tabs.reduce((acc, tab) => {
                            acc[tab.label] = {
                                name: tab.label,
                                showMore: this.$_.get(this.groupedItems, `${tab.label}.showMore`, true),
                                isDraggable: tab.draggable || false,
                                items: [],
                            };
                            return acc;
                        }, {}),
                    },
                    noGrouped: [],
                }
            );
            this.groupedItems = items.grouped;
            this.cloneItems = items.noGrouped;
        },
        onDragEnd(groupItem) {
            this.$emit("dragEnd", {
                groupName: groupItem.name,
                items: groupItem.items,
            });
        },
        onNonGroupedDragEnd() {
            this.$emit("dragEnd", {
                groupName: null,
                items: this.cloneItems,
            });
        },
        /**
         * Mobil ve masaüstü için farklı draggable seçenekleri döndürür
         * Mobil cihazlarda uzun basma (long press) ile drag başlar
         */
        getDraggableOptions() {
            return {
                animation: 200,
                handle: '.sidebar-menu-item',
                delay: this.isMobile ? 300 : 0, // Mobilde 300ms gecikme ekle
                delayOnTouchOnly: true, // Gecikmeyi sadece touch olaylarına uygula
                touchStartThreshold: 5, // 5px'den az hareket drag sayılmaz
            };
        },
        hasSuperAdminAccess(superAdminPageKey) {
            if (!this.adminUser) return true;
            if (this.adminUser.isFullAccess) return true;
            if (!superAdminPageKey) return true;
            return (this.adminUser.approvedPages || []).map((x) => x.page).includes(superAdminPageKey);
        },
        handleRouteClick(item, event) {
            if (this.adminUser && item.superAdminPageKey) {
                if (!this.hasSuperAdminAccess(item.superAdminPageKey)) {
                    event.preventDefault();
                    this.$router.push("/");
                }
            }
        },
    },
    mounted() {
        console.log("SidebarChild mounted");
        this.initData();
    },
    watch: {
        items: {
            deep: true,
            handler() {
                this.initData();
            },
        },
        selectedItem() {
            if (this.selectedItemClone !== this.selectedItem) {
                this.selectedItemClone = this.selectedItem;
            }
        },
        menu: {
            handler(newVal) {
                if (newVal.isOpen || newVal.hoverActive) {
                    this.hoverActive = false;
                }
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss">
.hiddenToolTip {
    opacity: 0 !important;
    display: none !important;
}

#contents.mobile-contents {
    .sidebar-tool {
        position: absolute !important;
        height: calc(100vh - 56px);
    }
}
</style>
<style lang="scss">
.sidebar-tool {
    width: 60px;
    border-right: 1px solid var(--color-border-default);
    height: 100%;
    position: relative;
    transition: all 0.2s;
    user-select: none;
    min-width: 60px;
    z-index: 99;

    .sidebar-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 10px;
        .material-icons {
                font-size: 18px !important;
                color: #22272d !important;
            }
        &-text {
            font-size: 20px;
            font-weight: 600;
            color: #22272d;
        }
        &-actions {
            display: flex;
            align-items: center;
            gap: 10px;

            .sidebar-title-action {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                cursor: pointer;
                user-select: none;
                border: 1px solid var(--color-border-default);
            }
        }
    }

    .sidebar-content {
        height: calc(100% - 40px);
        overflow: auto;
        background: var(--color-bg-default);
        // Touch cihazlar için smooth scroll
        -webkit-overflow-scrolling: touch;
        overscroll-behavior: contain;

        &::-webkit-scrollbar {
            display: none;
        }
    }

    &.active {
        width: 240px;
        min-width: 240px;

        .sidebar-menu-item {
            .sidebar-menu-item-content {
                display: flex !important;
                align-items: center !important;
                justify-content: space-between;
                width: 100% !important;
            }
        }

        .sidebar-grouped {
            .sidebar-grouped-head {
                justify-content: space-between;

                .sidebar-grouped-head-title {
                    display: block !important;
                }
            }
        }

        .sidebar-tool-collapse {
            padding: 0 10px;
            justify-content: space-between;

            .information-text {
                display: block !important;
            }
        }
    }

    .sidebar-menu {
        transition: all 0.2s;
        max-height: 800px; // 10 item
        overflow: hidden;
        opacity: 1;

        &.closed {
            max-height: 0;
            opacity: 0;
        }
    }

    .sidebar-menu-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 2px;
        line-height: 0;
        background: var(--color-bg-default) !important;

        a {
            width: 100%;
            color: black;
        }
    }

    .sidebar-grouped {
        width: 100%;
        display: flex;
        flex-direction: column;

        .sidebar-grouped-head {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            border: var(--color-border-default);
            border-style: solid;
            border-width: 1px 0;
            border-bottom-width: 0;
            padding: 10px 15px;
            cursor: pointer;
            // Touch cihazlar için optimizasyonlar
            touch-action: manipulation;
            -webkit-tap-highlight-color: rgba(86, 37, 204, 0.1);
            -webkit-touch-callout: none;

            &:active {
                background: var(--color-bg-neutral-hover);
            }

            .sidebar-grouped-head-title {
                display: none;
                white-space: nowrap;
                width: 100%;
                line-height: 0;
            }

            .sidebar-grouped-head-collapse {
                line-height: 0;

                .material-icons {
                    font-size: 16px;
                }
            }
        }
    }

    .sidebar-tool-collapse {
        position: absolute;
        border-top: 1px solid var(--color-border-default);
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        cursor: pointer;
        user-select: none;
        background: var(--color-bg-default) !important;
        height: 40px;
        color: var(--default-text-color);
        // Touch cihazlar için optimizasyonlar
        touch-action: manipulation;
        -webkit-tap-highlight-color: rgba(86, 37, 204, 0.1);
        -webkit-touch-callout: none;

        &:active {
            background: var(--color-bg-neutral-hover) !important;
        }

        .information-text {
            display: none;
            white-space: nowrap;
        }
    }
}

.menu-item {
    display: block;
    width: 100%;
    text-decoration: none;

    .menu-item-label {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        flex: 1;
        min-width: 0;
    }
}
</style>
